export enum TableHeaderType {
  Text = 'text',
  Numeric = 'numeric',
  Boolean = 'boolean',
  Date = 'date',
  Enum = 'enum',
  Avatar = 'Avatar',
  Location = 'Location',
  AssignUser = 'AssignUser',
  Action = 'Action',
  StatusBadges = 'StatusBadges',
  DateRange = 'DateRange',
  Link = 'link',
  clickAction = 'clickAction',
}
